// extracted by mini-css-extract-plugin
export var content = "_ly-1";
export var fullScreen = "_ly-0";